import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Play, Sparkles, Trophy, ChevronRight, Zap } from 'lucide-react';

const HomePage = () => {
  const navigate = useNavigate();

  return (
    <div className="home-container fade-in">
      {/* --- HERO SECTION --- */}
      <section className="hero-card">
        <div className="hero-content">
          <div className="badge">
            <Sparkles size={14} /> <span>Latest Ringtone</span>
          </div>
          <h1> Best  Ringtone<span> Latest Available </span></h1>
          <p>Vibe with best high-quality Song with RizzTone </p>
          <button className="primary-btn" onClick={() => navigate('/list')}>
            <Play size={18} fill="currentColor" /> Start Listening
          </button>
        </div>
      </section>

    
      {/* --- NAVIGATION SHORTCUTS --- */}
      <section className="shortcuts">
        <h3 className="section-label">Jump Back In</h3>
        
        <div className="shortcut-card" onClick={() => navigate('/list')}>
          <div className="shortcut-info">
            <div className="shortcut-icon explore">
              <Zap size={20} />
            </div>
            <div>
              <h4>Explore Library</h4>
              <p>Discover new vibes</p>
            </div>
          </div>
          <ChevronRight size={20} color="var(--text-dim)" />
        </div>

        <div className="shortcut-card" onClick={() => navigate('/saved')}>
          <div className="shortcut-info">
            <div className="shortcut-icon library">
              <Trophy size={20} />
            </div>
            <div>
              <h4>Your Favorites</h4>
              <p>Saved to library</p>
            </div>
          </div>
          <ChevronRight size={20} color="var(--text-dim)" />
        </div>
      </section>
    </div>
  );
};

export default HomePage;